// AUTOGENERATED FILE
// see insights/generate_metric_types.py
import { MetricTypes } from "./metrics";

export enum MetricAggregationType {
  Simple = "Simple",
  Ratio = "Ratio",
  String = "String",
  Mean = "Mean",
}

// We could generalise to take a function to generate metrics, but I think a bit of structure is nice
export type MetricAggregationData =
  | {
      type: MetricAggregationType.Simple;
      name: MetricTypes;
    }
  | {
      type: MetricAggregationType.Ratio;
      name: MetricTypes;
      numerator: MetricTypes;
      denominator: MetricTypes;
    }
  | {
      type: MetricAggregationType.String;
      name: MetricTypes;
    }
  | {
      type: MetricAggregationType.Mean;
      name: MetricTypes;
    };

export const MetricDataMap: Partial<Record<MetricTypes, MetricAggregationData>> = {
  [MetricTypes.PERCENT_OF_TOTAL_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PERCENT_OF_TOTAL_REVENUE,
  },
  [MetricTypes.PERCENT_OF_TOTAL_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PERCENT_OF_TOTAL_SPEND,
  },
  [MetricTypes.AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AOV,
    numerator: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
    denominator: MetricTypes.TOTAL_ORDER_QUANTITY,
  },
  [MetricTypes.ACTIVE_CAMPAIGNS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ACTIVE_CAMPAIGNS,
  },
  [MetricTypes.AD_PLATFORM_REPORTED_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_PLATFORM_REPORTED_REVENUE,
  },
  [MetricTypes.ALL_TIME_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ALL_TIME_REVENUE,
  },
  [MetricTypes.ALL_TIME_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ALL_TIME_SPEND,
  },
  [MetricTypes.CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.CAC,
    numerator: MetricTypes.MARKETING_SPEND,
    denominator: MetricTypes.TOTAL_UNIQUE_NEW_CUSTOMER_COUNT,
  },
  [MetricTypes.CUSTOMERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.CUSTOMERS,
  },
  [MetricTypes.CUSTOMERS_EXISTING]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.CUSTOMERS_EXISTING,
  },
  [MetricTypes.CUSTOMERS_NEW]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.CUSTOMERS_NEW,
  },
  [MetricTypes.CUSTOMERS_NEW_PERCENTAGE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.CUSTOMERS_NEW_PERCENTAGE,
  },
  [MetricTypes.CUSTOMERS_TOTAL]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.CUSTOMERS_TOTAL,
  },
  [MetricTypes.DISCOUNTS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.DISCOUNTS,
  },
  [MetricTypes.AD_ADDED_TO_CART]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_ADDED_TO_CART,
  },
  [MetricTypes.AD_CLICKS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_CLICKS,
  },
  [MetricTypes.AD_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_FREQUENCY,
    numerator: MetricTypes.AD_IMPRESSIONS,
    denominator: MetricTypes.AD_REACH,
  },
  [MetricTypes.AD_IMPRESSIONS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_IMPRESSIONS,
  },
  [MetricTypes.AD_REACH]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_REACH,
  },
  [MetricTypes.AD_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_SPEND,
  },
  [MetricTypes.AD_VIEWS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_VIEWS,
  },
  [MetricTypes.AD_CTR]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_CTR,
    numerator: MetricTypes.AD_CLICKS,
    denominator: MetricTypes.AD_IMPRESSIONS,
  },
  [MetricTypes.AD_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_AOV,
    numerator: MetricTypes.AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.AD_CONVERSION_RATE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_CONVERSION_RATE,
    numerator: MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT,
    denominator: MetricTypes.AD_VIEWS,
  },
  [MetricTypes.AD_COST_PER_CONVERSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_COST_PER_CONVERSION,
    numerator: MetricTypes.AD_SPEND,
    denominator: MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_COST_PER_IMPRESSION,
    numerator: MetricTypes.AD_SPEND,
    denominator: MetricTypes.AD_IMPRESSIONS,
  },
  [MetricTypes.AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_COST_PER_CLICK,
    numerator: MetricTypes.AD_SPEND,
    denominator: MetricTypes.AD_CLICKS,
  },
  [MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AD_ATTRIBUTED_CONVERSION_ROAS,
    numerator: MetricTypes.AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.AD_SPEND,
  },
  [MetricTypes.AD_ATTRIBUTED_CONVERSION_VALUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_ATTRIBUTED_CONVERSION_VALUE,
  },
  [MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.MARKETING_EFFICIENCY_RATIO]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.MARKETING_EFFICIENCY_RATIO,
    numerator: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
    denominator: MetricTypes.AD_SPEND,
  },
  [MetricTypes.ACQUISITION_MARKETING_EFFICIENCY_RATIO]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ACQUISITION_MARKETING_EFFICIENCY_RATIO,
    numerator: MetricTypes.ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
    denominator: MetricTypes.AD_SPEND,
  },
  [MetricTypes.BLENDED_AD_CLICKS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_CLICKS,
  },
  [MetricTypes.BLENDED_AD_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_FREQUENCY,
    numerator: MetricTypes.BLENDED_AD_IMPRESSIONS,
    denominator: MetricTypes.BLENDED_AD_REACH,
  },
  [MetricTypes.BLENDED_AD_IMPRESSIONS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_IMPRESSIONS,
  },
  [MetricTypes.BLENDED_AD_REACH]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_REACH,
  },
  [MetricTypes.BLENDED_AD_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_SPEND,
  },
  [MetricTypes.BLENDED_AD_VIEWS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_VIEWS,
  },
  [MetricTypes.BLENDED_AD_CTR]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_CTR,
    numerator: MetricTypes.BLENDED_AD_CLICKS,
    denominator: MetricTypes.BLENDED_AD_IMPRESSIONS,
  },
  [MetricTypes.BLENDED_AD_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_AOV,
    numerator: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.BLENDED_AD_CONVERSION_RATE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_CONVERSION_RATE,
    numerator: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT,
    denominator: MetricTypes.BLENDED_AD_VIEWS,
  },
  [MetricTypes.BLENDED_AD_COST_PER_CONVERSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_COST_PER_CONVERSION,
    numerator: MetricTypes.BLENDED_AD_SPEND,
    denominator: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.BLENDED_AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_COST_PER_IMPRESSION,
    numerator: MetricTypes.BLENDED_AD_SPEND,
    denominator: MetricTypes.BLENDED_AD_IMPRESSIONS,
  },
  [MetricTypes.BLENDED_AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_COST_PER_CLICK,
    numerator: MetricTypes.BLENDED_AD_SPEND,
    denominator: MetricTypes.BLENDED_AD_CLICKS,
  },
  [MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE,
  },
  [MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS,
    numerator: MetricTypes.BLENDED_AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.BLENDED_AD_SPEND,
  },
  [MetricTypes.BLENDED_AD_RELATIVE_PERCENTAGE_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BLENDED_AD_RELATIVE_PERCENTAGE_SPEND,
  },
  [MetricTypes.META_AD_ADDED_TO_CART]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_ADDED_TO_CART,
  },
  [MetricTypes.META_AD_CLICKS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_CLICKS,
  },
  [MetricTypes.META_AD_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_FREQUENCY,
    numerator: MetricTypes.META_AD_IMPRESSIONS,
    denominator: MetricTypes.META_AD_REACH,
  },
  [MetricTypes.META_AD_IMPRESSIONS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_IMPRESSIONS,
  },
  [MetricTypes.META_AD_REACH]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_REACH,
  },
  [MetricTypes.META_AD_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_SPEND,
  },
  [MetricTypes.META_AD_VIEWS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_VIEWS,
  },
  [MetricTypes.META_AD_CTR]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_CTR,
    numerator: MetricTypes.META_AD_CLICKS,
    denominator: MetricTypes.META_AD_IMPRESSIONS,
  },
  [MetricTypes.META_AD_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_AOV,
    numerator: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.META_AD_CONVERSION_RATE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_CONVERSION_RATE,
    numerator: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT,
    denominator: MetricTypes.META_AD_VIEWS,
  },
  [MetricTypes.META_AD_COST_PER_CONVERSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_COST_PER_CONVERSION,
    numerator: MetricTypes.META_AD_SPEND,
    denominator: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.META_AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_COST_PER_IMPRESSION,
    numerator: MetricTypes.META_AD_SPEND,
    denominator: MetricTypes.META_AD_IMPRESSIONS,
  },
  [MetricTypes.META_AD_COST_PER_MILLE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_COST_PER_MILLE,
  },
  [MetricTypes.META_AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_COST_PER_CLICK,
    numerator: MetricTypes.META_AD_SPEND,
    denominator: MetricTypes.META_AD_CLICKS,
  },
  [MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.META_AD_ATTRIBUTED_CONVERSION_VALUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_VALUE,
  },
  [MetricTypes.META_AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_ROAS,
    numerator: MetricTypes.META_AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.META_AD_SPEND,
  },
  [MetricTypes.META_AD_RELATIVE_PERCENTAGE_SPEND]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.META_AD_RELATIVE_PERCENTAGE_SPEND,
    numerator: MetricTypes.META_AD_SPEND,
    denominator: MetricTypes.AD_SPEND,
  },
  [MetricTypes.GOOGLE_AD_CLICKS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_CLICKS,
  },
  [MetricTypes.GOOGLE_AD_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_FREQUENCY,
    numerator: MetricTypes.GOOGLE_AD_IMPRESSIONS,
    denominator: MetricTypes.GOOGLE_AD_REACH,
  },
  [MetricTypes.GOOGLE_AD_IMPRESSIONS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_IMPRESSIONS,
  },
  [MetricTypes.GOOGLE_AD_REACH]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_REACH,
  },
  [MetricTypes.GOOGLE_AD_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_SPEND,
  },
  [MetricTypes.GOOGLE_AD_VIEWS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_VIEWS,
  },
  [MetricTypes.GOOGLE_AD_CTR]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_CTR,
    numerator: MetricTypes.GOOGLE_AD_CLICKS,
    denominator: MetricTypes.GOOGLE_AD_IMPRESSIONS,
  },
  [MetricTypes.GOOGLE_AD_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_AOV,
    numerator: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.GOOGLE_AD_CONVERSION_RATE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_CONVERSION_RATE,
    numerator: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT,
    denominator: MetricTypes.GOOGLE_AD_VIEWS,
  },
  [MetricTypes.GOOGLE_AD_COST_PER_CONVERSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_COST_PER_CONVERSION,
    numerator: MetricTypes.GOOGLE_AD_SPEND,
    denominator: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.GOOGLE_AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_COST_PER_IMPRESSION,
    numerator: MetricTypes.GOOGLE_AD_SPEND,
    denominator: MetricTypes.GOOGLE_AD_IMPRESSIONS,
  },
  [MetricTypes.GOOGLE_AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_COST_PER_CLICK,
    numerator: MetricTypes.GOOGLE_AD_SPEND,
    denominator: MetricTypes.GOOGLE_AD_CLICKS,
  },
  [MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_COUNT,
  },
  [MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE,
  },
  [MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS,
    numerator: MetricTypes.GOOGLE_AD_ATTRIBUTED_CONVERSION_VALUE,
    denominator: MetricTypes.GOOGLE_AD_SPEND,
  },
  [MetricTypes.GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND,
    numerator: MetricTypes.GOOGLE_AD_SPEND,
    denominator: MetricTypes.AD_SPEND,
  },
  [MetricTypes.TIKTOK_AD_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TIKTOK_AD_SPEND,
  },
  [MetricTypes.TIKTOK_ACCOUNT_ID]: {
    type: MetricAggregationType.String,
    name: MetricTypes.TIKTOK_ACCOUNT_ID,
  },
  [MetricTypes.TIKTOK_ACCOUNT_NAME]: {
    type: MetricAggregationType.String,
    name: MetricTypes.TIKTOK_ACCOUNT_NAME,
  },
  [MetricTypes.TIKTOK_WAYFLYER_BC_ID]: {
    type: MetricAggregationType.String,
    name: MetricTypes.TIKTOK_WAYFLYER_BC_ID,
  },
  [MetricTypes.GROSS_ITEM_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_ITEM_QUANTITY,
  },
  [MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS,
  },
  [MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_REFUNDS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_REFUNDS,
  },
  [MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS,
  },
  [MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_ORDERS,
  },
  [MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_REFUNDS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_PRODUCT_REVENUE_FROM_ORDER_PROPORTION_LESS_DISCOUNTS_LESS_REFUNDED_AMOUNT_FROM_REFUNDS,
  },
  [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_BY_REFUNDED_DATE_PLUS_SHIPPING_PLUS_TAX]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_BY_REFUNDED_DATE_PLUS_SHIPPING_PLUS_TAX,
  },
  [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_FROM_ORDERS_PLUS_SHIPPING_PLUS_TAX]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_FROM_ORDERS_PLUS_SHIPPING_PLUS_TAX,
  },
  [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_PLUS_SHIPPING_PLUS_TAX]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_LESS_REFUNDS_PLUS_SHIPPING_PLUS_TAX,
  },
  [MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
  },
  [MetricTypes.ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ACQUISITION_GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
  },
  [MetricTypes.GROSS_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_REVENUE,
  },
  [MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY,
  },
  [MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS,
  },
  [MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT,
    numerator: MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY,
    denominator: MetricTypes.PRODUCT_QUANTITY,
  },
  [MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ITEM_LEVEL_NEW_CUSTOMER_PERCENT_FROM_PRODUCTS,
    numerator: MetricTypes.NEW_CUSTOMER_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS,
    denominator: MetricTypes.GROSS_ITEM_QUANTITY_LESS_REFUNDED_QUANTITY_FROM_PRODUCTS,
  },
  [MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_PRODUCTS,
    numerator: MetricTypes.PRODUCT_REFUNDS_FROM_PRODUCTS,
    denominator: MetricTypes.PRODUCT_QUANTITY,
  },
  [MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ITEM_LEVEL_RETURN_RATE_FROM_REFUNDS,
    numerator: MetricTypes.PRODUCT_REFUNDS_FROM_REFUNDS,
    denominator: MetricTypes.PRODUCT_QUANTITY,
  },
  [MetricTypes.RETURNING_CUSTOMER_PERCENTAGE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.RETURNING_CUSTOMER_PERCENTAGE,
  },
  [MetricTypes.LTV]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.LTV,
  },
  [MetricTypes.LINK_CLICKS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.LINK_CLICKS,
  },
  [MetricTypes.MARKETING_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.MARKETING_SPEND,
  },
  [MetricTypes.LTV_CAC_MONTH]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.LTV_CAC_MONTH,
  },
  [MetricTypes.MONTH_FIRST_ORDER]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.MONTH_FIRST_ORDER,
  },
  [MetricTypes.NET_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NET_QUANTITY,
  },
  [MetricTypes.NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NET_REVENUE,
  },
  [MetricTypes.NET_SALES_EXISTING]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NET_SALES_EXISTING,
  },
  [MetricTypes.NET_SALES_NEW]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NET_SALES_NEW,
  },
  [MetricTypes.NET_SALES_NEW_PERCENTAGE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NET_SALES_NEW_PERCENTAGE,
  },
  [MetricTypes.NET_SALES_TOTAL]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NET_SALES_TOTAL,
  },
  [MetricTypes.NEW_CUSTOMERS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NEW_CUSTOMERS,
    numerator: MetricTypes.TOTAL_UNIQUE_NEW_CUSTOMER_COUNT,
    denominator: MetricTypes.TOTAL_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ORDERS,
  },
  [MetricTypes.ORDERS_EXISTING]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ORDERS_EXISTING,
  },
  [MetricTypes.ORDERS_NEW]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ORDERS_NEW,
  },
  [MetricTypes.ORDERS_NEW_PERCENTAGE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ORDERS_NEW_PERCENTAGE,
  },
  [MetricTypes.ORDERS_TOTAL]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ORDERS_TOTAL,
  },
  [MetricTypes.PRODUCT_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PRODUCT_QUANTITY,
  },
  [MetricTypes.PRODUCT_REFUNDS_FROM_PRODUCTS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PRODUCT_REFUNDS_FROM_PRODUCTS,
  },
  [MetricTypes.PRODUCT_REFUNDS_FROM_REFUNDS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PRODUCT_REFUNDS_FROM_REFUNDS,
  },
  [MetricTypes.QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.QUANTITY,
  },
  [MetricTypes.LTV_CAC_QUARTER]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.LTV_CAC_QUARTER,
  },
  [MetricTypes.QUARTER_FIRST_ORDER]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.QUARTER_FIRST_ORDER,
  },
  [MetricTypes.ROAS]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ROAS,
    numerator: MetricTypes.GROSS_REVENUE_LESS_DISCOUNTS_PLUS_SHIPPING_PLUS_TAX,
    denominator: MetricTypes.MARKETING_SPEND,
  },
  [MetricTypes.REFUNDS_PERCENT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.REFUNDS_PERCENT,
  },
  [MetricTypes.RETURN_RATE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.RETURN_RATE,
  },
  [MetricTypes.RETURNS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.RETURNS,
  },
  [MetricTypes.REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.REVENUE,
  },
  [MetricTypes.SALES]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES,
  },
  [MetricTypes.SALES_EXISTING]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES_EXISTING,
  },
  [MetricTypes.SALES_NEW]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES_NEW,
  },
  [MetricTypes.SALES_NEW_PERCENTAGE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES_NEW_PERCENTAGE,
  },
  [MetricTypes.SALES_TOTAL]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES_TOTAL,
  },
  [MetricTypes.SALES_EXCLUDING_REFUNDS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES_EXCLUDING_REFUNDS,
  },
  [MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY,
  },
  [MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY,
  },
  [MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY_LESS_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE,
  },
  [MetricTypes.TOTAL_ORDER_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_ORDER_QUANTITY,
  },
  [MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY,
  },
  [MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE,
  },
  [MetricTypes.TOTAL_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TOTAL_UNIQUE_NEW_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_UNIQUE_NEW_CUSTOMER_COUNT,
  },
  [MetricTypes.TOTAL_SALES]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TOTAL_SALES,
  },
  [MetricTypes.TRANSACTIONS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TRANSACTIONS,
  },
  [MetricTypes.LTV_CAC_YEAR]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.LTV_CAC_YEAR,
  },
  [MetricTypes.YEAR_FIRST_ORDER]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.YEAR_FIRST_ORDER,
  },
  [MetricTypes.ADDITIONAL_COGS_AND_SHIPPING]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ADDITIONAL_COGS_AND_SHIPPING,
  },
  [MetricTypes.ADDITIONAL_OPEX]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ADDITIONAL_OPEX,
  },
  [MetricTypes.COGS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.COGS,
  },
  [MetricTypes.GROSS_PROFIT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_PROFIT,
  },
  [MetricTypes.GROSS_MARGIN_PERCENTAGE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_MARGIN_PERCENTAGE,
  },
  [MetricTypes.FCP]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FCP,
  },
  [MetricTypes.TEST_METRIC]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TEST_METRIC,
  },
  [MetricTypes.PROFIT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PROFIT,
  },
  [MetricTypes.PERCENTAGE_OF_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PERCENTAGE_OF_SPEND,
  },
  [MetricTypes.PERCENTAGE_OF_TOTAL_AD_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PERCENTAGE_OF_TOTAL_AD_SPEND,
  },
  [MetricTypes.AVERAGE_UNITS_PER_ORDER]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.AVERAGE_UNITS_PER_ORDER,
    numerator: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY,
    denominator: MetricTypes.TOTAL_ORDER_QUANTITY,
  },
  [MetricTypes.REFUNDED_ITEM_PERCENTAGE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.REFUNDED_ITEM_PERCENTAGE,
    numerator: MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY,
    denominator: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY,
  },
  [MetricTypes.REFUNDED_ITEM_PERCENTAGE_BY_REFUNDED_DATE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.REFUNDED_ITEM_PERCENTAGE_BY_REFUNDED_DATE,
    numerator: MetricTypes.TOTAL_REFUNDED_ITEM_QUANTITY_BY_REFUNDED_DATE,
    denominator: MetricTypes.TOTAL_ORDERED_ITEM_QUANTITY,
  },
  [MetricTypes.AVERAGE_DAILY_UNITS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.AVERAGE_DAILY_UNITS,
  },
  [MetricTypes.SALES_VELOCITY_THIRTY_DAYS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SALES_VELOCITY_THIRTY_DAYS,
  },
  [MetricTypes.GROSS_PRODUCT_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.GROSS_PRODUCT_REVENUE,
  },
  [MetricTypes.PRODUCT_LEVEL_DISCOUNT_PCT]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.PRODUCT_LEVEL_DISCOUNT_PCT,
    numerator: MetricTypes.PRODUCT_LEVEL_DISCOUNT_VALUE,
    denominator: MetricTypes.GROSS_PRODUCT_REVENUE,
  },
  [MetricTypes.PRODUCT_LEVEL_DISCOUNT_VALUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.PRODUCT_LEVEL_DISCOUNT_VALUE,
  },
  [MetricTypes.SESSION_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SESSION_COUNT,
  },
  [MetricTypes.CONVERSION_RATE]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.CONVERSION_RATE,
    numerator: MetricTypes.TOTAL_ORDER_QUANTITY,
    denominator: MetricTypes.SESSION_COUNT,
  },
  [MetricTypes.STORE_NAME]: {
    type: MetricAggregationType.String,
    name: MetricTypes.STORE_NAME,
  },
  [MetricTypes.ALLTIME_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ALLTIME_AOV,
    numerator: MetricTypes.ALLTIME_NET_REVENUE,
    denominator: MetricTypes.ALLTIME_ORDERS,
  },
  [MetricTypes.ALLTIME_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ALLTIME_FREQUENCY,
    numerator: MetricTypes.ALLTIME_ORDERS,
    denominator: MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ALLTIME_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ALLTIME_LTV,
    numerator: MetricTypes.ALLTIME_NET_REVENUE,
    denominator: MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ALLTIME_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ALLTIME_NET_REVENUE,
  },
  [MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ALLTIME_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ALLTIME_ORDERS,
  },
  [MetricTypes.ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.ALLTIME_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ALLTIME_CAC,
    numerator: MetricTypes.ALLTIME_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.ALLTIME_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SAME_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SAME_MONTH_AOV,
    numerator: MetricTypes.SAME_MONTH_NET_REVENUE,
    denominator: MetricTypes.SAME_MONTH_ORDERS,
  },
  [MetricTypes.SAME_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SAME_MONTH_FREQUENCY,
    numerator: MetricTypes.SAME_MONTH_ORDERS,
    denominator: MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SAME_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SAME_MONTH_LTV,
    numerator: MetricTypes.SAME_MONTH_NET_REVENUE,
    denominator: MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SAME_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SAME_MONTH_NET_REVENUE,
  },
  [MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SAME_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SAME_MONTH_ORDERS,
  },
  [MetricTypes.SAME_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SAME_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.SAME_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SAME_MONTH_CAC,
    numerator: MetricTypes.SAME_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.SAME_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ONE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ONE_MONTH_AOV,
    numerator: MetricTypes.ONE_MONTH_NET_REVENUE,
    denominator: MetricTypes.ONE_MONTH_ORDERS,
  },
  [MetricTypes.ONE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ONE_MONTH_FREQUENCY,
    numerator: MetricTypes.ONE_MONTH_ORDERS,
    denominator: MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ONE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ONE_MONTH_LTV,
    numerator: MetricTypes.ONE_MONTH_NET_REVENUE,
    denominator: MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ONE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ONE_MONTH_NET_REVENUE,
  },
  [MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ONE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ONE_MONTH_ORDERS,
  },
  [MetricTypes.ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.ONE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ONE_MONTH_CAC,
    numerator: MetricTypes.ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWO_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWO_MONTH_AOV,
    numerator: MetricTypes.TWO_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWO_MONTH_ORDERS,
  },
  [MetricTypes.TWO_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWO_MONTH_FREQUENCY,
    numerator: MetricTypes.TWO_MONTH_ORDERS,
    denominator: MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWO_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWO_MONTH_LTV,
    numerator: MetricTypes.TWO_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWO_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWO_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWO_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWO_MONTH_ORDERS,
  },
  [MetricTypes.TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWO_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWO_MONTH_CAC,
    numerator: MetricTypes.TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THREE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THREE_MONTH_AOV,
    numerator: MetricTypes.THREE_MONTH_NET_REVENUE,
    denominator: MetricTypes.THREE_MONTH_ORDERS,
  },
  [MetricTypes.THREE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THREE_MONTH_FREQUENCY,
    numerator: MetricTypes.THREE_MONTH_ORDERS,
    denominator: MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THREE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THREE_MONTH_LTV,
    numerator: MetricTypes.THREE_MONTH_NET_REVENUE,
    denominator: MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THREE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THREE_MONTH_NET_REVENUE,
  },
  [MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THREE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THREE_MONTH_ORDERS,
  },
  [MetricTypes.THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.THREE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THREE_MONTH_CAC,
    numerator: MetricTypes.THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOUR_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOUR_MONTH_AOV,
    numerator: MetricTypes.FOUR_MONTH_NET_REVENUE,
    denominator: MetricTypes.FOUR_MONTH_ORDERS,
  },
  [MetricTypes.FOUR_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOUR_MONTH_FREQUENCY,
    numerator: MetricTypes.FOUR_MONTH_ORDERS,
    denominator: MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOUR_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOUR_MONTH_LTV,
    numerator: MetricTypes.FOUR_MONTH_NET_REVENUE,
    denominator: MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOUR_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOUR_MONTH_NET_REVENUE,
  },
  [MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOUR_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOUR_MONTH_ORDERS,
  },
  [MetricTypes.FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.FOUR_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOUR_MONTH_CAC,
    numerator: MetricTypes.FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIVE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIVE_MONTH_AOV,
    numerator: MetricTypes.FIVE_MONTH_NET_REVENUE,
    denominator: MetricTypes.FIVE_MONTH_ORDERS,
  },
  [MetricTypes.FIVE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIVE_MONTH_FREQUENCY,
    numerator: MetricTypes.FIVE_MONTH_ORDERS,
    denominator: MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIVE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIVE_MONTH_LTV,
    numerator: MetricTypes.FIVE_MONTH_NET_REVENUE,
    denominator: MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIVE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIVE_MONTH_NET_REVENUE,
  },
  [MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIVE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIVE_MONTH_ORDERS,
  },
  [MetricTypes.FIVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.FIVE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIVE_MONTH_CAC,
    numerator: MetricTypes.FIVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.FIVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIX_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIX_MONTH_AOV,
    numerator: MetricTypes.SIX_MONTH_NET_REVENUE,
    denominator: MetricTypes.SIX_MONTH_ORDERS,
  },
  [MetricTypes.SIX_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIX_MONTH_FREQUENCY,
    numerator: MetricTypes.SIX_MONTH_ORDERS,
    denominator: MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIX_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIX_MONTH_LTV,
    numerator: MetricTypes.SIX_MONTH_NET_REVENUE,
    denominator: MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIX_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIX_MONTH_NET_REVENUE,
  },
  [MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIX_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIX_MONTH_ORDERS,
  },
  [MetricTypes.SIX_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIX_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.SIX_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIX_MONTH_CAC,
    numerator: MetricTypes.SIX_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.SIX_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVEN_MONTH_AOV,
    numerator: MetricTypes.SEVEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.SEVEN_MONTH_ORDERS,
  },
  [MetricTypes.SEVEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVEN_MONTH_FREQUENCY,
    numerator: MetricTypes.SEVEN_MONTH_ORDERS,
    denominator: MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVEN_MONTH_LTV,
    numerator: MetricTypes.SEVEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVEN_MONTH_ORDERS,
  },
  [MetricTypes.SEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.SEVEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVEN_MONTH_CAC,
    numerator: MetricTypes.SEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.SEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHT_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHT_MONTH_AOV,
    numerator: MetricTypes.EIGHT_MONTH_NET_REVENUE,
    denominator: MetricTypes.EIGHT_MONTH_ORDERS,
  },
  [MetricTypes.EIGHT_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHT_MONTH_FREQUENCY,
    numerator: MetricTypes.EIGHT_MONTH_ORDERS,
    denominator: MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHT_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHT_MONTH_LTV,
    numerator: MetricTypes.EIGHT_MONTH_NET_REVENUE,
    denominator: MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHT_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHT_MONTH_NET_REVENUE,
  },
  [MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHT_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHT_MONTH_ORDERS,
  },
  [MetricTypes.EIGHT_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHT_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.EIGHT_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHT_MONTH_CAC,
    numerator: MetricTypes.EIGHT_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.EIGHT_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINE_MONTH_AOV,
    numerator: MetricTypes.NINE_MONTH_NET_REVENUE,
    denominator: MetricTypes.NINE_MONTH_ORDERS,
  },
  [MetricTypes.NINE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINE_MONTH_FREQUENCY,
    numerator: MetricTypes.NINE_MONTH_ORDERS,
    denominator: MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINE_MONTH_LTV,
    numerator: MetricTypes.NINE_MONTH_NET_REVENUE,
    denominator: MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINE_MONTH_NET_REVENUE,
  },
  [MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINE_MONTH_ORDERS,
  },
  [MetricTypes.NINE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.NINE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINE_MONTH_CAC,
    numerator: MetricTypes.NINE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.NINE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TEN_MONTH_AOV,
    numerator: MetricTypes.TEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.TEN_MONTH_ORDERS,
  },
  [MetricTypes.TEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TEN_MONTH_FREQUENCY,
    numerator: MetricTypes.TEN_MONTH_ORDERS,
    denominator: MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TEN_MONTH_LTV,
    numerator: MetricTypes.TEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TEN_MONTH_ORDERS,
  },
  [MetricTypes.TEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TEN_MONTH_CAC,
    numerator: MetricTypes.TEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ELEVEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ELEVEN_MONTH_AOV,
    numerator: MetricTypes.ELEVEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.ELEVEN_MONTH_ORDERS,
  },
  [MetricTypes.ELEVEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ELEVEN_MONTH_FREQUENCY,
    numerator: MetricTypes.ELEVEN_MONTH_ORDERS,
    denominator: MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ELEVEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ELEVEN_MONTH_LTV,
    numerator: MetricTypes.ELEVEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ELEVEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ELEVEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.ELEVEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ELEVEN_MONTH_ORDERS,
  },
  [MetricTypes.ELEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.ELEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.ELEVEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.ELEVEN_MONTH_CAC,
    numerator: MetricTypes.ELEVEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.ELEVEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWELVE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWELVE_MONTH_AOV,
    numerator: MetricTypes.TWELVE_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWELVE_MONTH_ORDERS,
  },
  [MetricTypes.TWELVE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWELVE_MONTH_FREQUENCY,
    numerator: MetricTypes.TWELVE_MONTH_ORDERS,
    denominator: MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWELVE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWELVE_MONTH_LTV,
    numerator: MetricTypes.TWELVE_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWELVE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWELVE_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWELVE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWELVE_MONTH_ORDERS,
  },
  [MetricTypes.TWELVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWELVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWELVE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWELVE_MONTH_CAC,
    numerator: MetricTypes.TWELVE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWELVE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THIRTEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THIRTEEN_MONTH_AOV,
    numerator: MetricTypes.THIRTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.THIRTEEN_MONTH_ORDERS,
  },
  [MetricTypes.THIRTEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THIRTEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.THIRTEEN_MONTH_ORDERS,
    denominator: MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THIRTEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THIRTEEN_MONTH_LTV,
    numerator: MetricTypes.THIRTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THIRTEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THIRTEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.THIRTEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THIRTEEN_MONTH_ORDERS,
  },
  [MetricTypes.THIRTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.THIRTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.THIRTEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.THIRTEEN_MONTH_CAC,
    numerator: MetricTypes.THIRTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.THIRTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOURTEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOURTEEN_MONTH_AOV,
    numerator: MetricTypes.FOURTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.FOURTEEN_MONTH_ORDERS,
  },
  [MetricTypes.FOURTEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOURTEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.FOURTEEN_MONTH_ORDERS,
    denominator: MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOURTEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOURTEEN_MONTH_LTV,
    numerator: MetricTypes.FOURTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOURTEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOURTEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FOURTEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOURTEEN_MONTH_ORDERS,
  },
  [MetricTypes.FOURTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FOURTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.FOURTEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FOURTEEN_MONTH_CAC,
    numerator: MetricTypes.FOURTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.FOURTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIFTEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIFTEEN_MONTH_AOV,
    numerator: MetricTypes.FIFTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.FIFTEEN_MONTH_ORDERS,
  },
  [MetricTypes.FIFTEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIFTEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.FIFTEEN_MONTH_ORDERS,
    denominator: MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIFTEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIFTEEN_MONTH_LTV,
    numerator: MetricTypes.FIFTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIFTEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIFTEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.FIFTEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIFTEEN_MONTH_ORDERS,
  },
  [MetricTypes.FIFTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.FIFTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.FIFTEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.FIFTEEN_MONTH_CAC,
    numerator: MetricTypes.FIFTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.FIFTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIXTEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIXTEEN_MONTH_AOV,
    numerator: MetricTypes.SIXTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.SIXTEEN_MONTH_ORDERS,
  },
  [MetricTypes.SIXTEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIXTEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.SIXTEEN_MONTH_ORDERS,
    denominator: MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIXTEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIXTEEN_MONTH_LTV,
    numerator: MetricTypes.SIXTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIXTEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIXTEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SIXTEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIXTEEN_MONTH_ORDERS,
  },
  [MetricTypes.SIXTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SIXTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.SIXTEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SIXTEEN_MONTH_CAC,
    numerator: MetricTypes.SIXTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.SIXTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVENTEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVENTEEN_MONTH_AOV,
    numerator: MetricTypes.SEVENTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.SEVENTEEN_MONTH_ORDERS,
  },
  [MetricTypes.SEVENTEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVENTEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.SEVENTEEN_MONTH_ORDERS,
    denominator: MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVENTEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVENTEEN_MONTH_LTV,
    numerator: MetricTypes.SEVENTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVENTEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVENTEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.SEVENTEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVENTEEN_MONTH_ORDERS,
  },
  [MetricTypes.SEVENTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.SEVENTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.SEVENTEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.SEVENTEEN_MONTH_CAC,
    numerator: MetricTypes.SEVENTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.SEVENTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHTEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHTEEN_MONTH_AOV,
    numerator: MetricTypes.EIGHTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.EIGHTEEN_MONTH_ORDERS,
  },
  [MetricTypes.EIGHTEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHTEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.EIGHTEEN_MONTH_ORDERS,
    denominator: MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHTEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHTEEN_MONTH_LTV,
    numerator: MetricTypes.EIGHTEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHTEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHTEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.EIGHTEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHTEEN_MONTH_ORDERS,
  },
  [MetricTypes.EIGHTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.EIGHTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.EIGHTEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.EIGHTEEN_MONTH_CAC,
    numerator: MetricTypes.EIGHTEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.EIGHTEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINETEEN_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINETEEN_MONTH_AOV,
    numerator: MetricTypes.NINETEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.NINETEEN_MONTH_ORDERS,
  },
  [MetricTypes.NINETEEN_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINETEEN_MONTH_FREQUENCY,
    numerator: MetricTypes.NINETEEN_MONTH_ORDERS,
    denominator: MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINETEEN_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINETEEN_MONTH_LTV,
    numerator: MetricTypes.NINETEEN_MONTH_NET_REVENUE,
    denominator: MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINETEEN_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINETEEN_MONTH_NET_REVENUE,
  },
  [MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.NINETEEN_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINETEEN_MONTH_ORDERS,
  },
  [MetricTypes.NINETEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.NINETEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.NINETEEN_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.NINETEEN_MONTH_CAC,
    numerator: MetricTypes.NINETEEN_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.NINETEEN_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_MONTH_AOV,
    numerator: MetricTypes.TWENTY_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_MONTH_FREQUENCY,
    numerator: MetricTypes.TWENTY_MONTH_ORDERS,
    denominator: MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_MONTH_LTV,
    numerator: MetricTypes.TWENTY_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWENTY_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_MONTH_CAC,
    numerator: MetricTypes.TWENTY_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWENTY_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_ONE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_ONE_MONTH_AOV,
    numerator: MetricTypes.TWENTY_ONE_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_ONE_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_ONE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_ONE_MONTH_FREQUENCY,
    numerator: MetricTypes.TWENTY_ONE_MONTH_ORDERS,
    denominator: MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_ONE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_ONE_MONTH_LTV,
    numerator: MetricTypes.TWENTY_ONE_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_ONE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_ONE_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_ONE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_ONE_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWENTY_ONE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_ONE_MONTH_CAC,
    numerator: MetricTypes.TWENTY_ONE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWENTY_ONE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_TWO_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_TWO_MONTH_AOV,
    numerator: MetricTypes.TWENTY_TWO_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_TWO_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_TWO_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_TWO_MONTH_FREQUENCY,
    numerator: MetricTypes.TWENTY_TWO_MONTH_ORDERS,
    denominator: MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_TWO_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_TWO_MONTH_LTV,
    numerator: MetricTypes.TWENTY_TWO_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_TWO_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_TWO_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_TWO_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_TWO_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWENTY_TWO_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_TWO_MONTH_CAC,
    numerator: MetricTypes.TWENTY_TWO_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWENTY_TWO_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_THREE_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_THREE_MONTH_AOV,
    numerator: MetricTypes.TWENTY_THREE_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_THREE_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_THREE_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_THREE_MONTH_FREQUENCY,
    numerator: MetricTypes.TWENTY_THREE_MONTH_ORDERS,
    denominator: MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_THREE_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_THREE_MONTH_LTV,
    numerator: MetricTypes.TWENTY_THREE_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_THREE_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_THREE_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_THREE_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_THREE_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWENTY_THREE_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_THREE_MONTH_CAC,
    numerator: MetricTypes.TWENTY_THREE_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWENTY_THREE_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_AOV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_FOUR_MONTH_AOV,
    numerator: MetricTypes.TWENTY_FOUR_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_FOUR_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_FREQUENCY]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_FOUR_MONTH_FREQUENCY,
    numerator: MetricTypes.TWENTY_FOUR_MONTH_ORDERS,
    denominator: MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_LTV]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_FOUR_MONTH_LTV,
    numerator: MetricTypes.TWENTY_FOUR_MONTH_NET_REVENUE,
    denominator: MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_NET_REVENUE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_FOUR_MONTH_NET_REVENUE,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_ORDERS]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_FOUR_MONTH_ORDERS,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.TWENTY_FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
  },
  [MetricTypes.TWENTY_FOUR_MONTH_CAC]: {
    type: MetricAggregationType.Ratio,
    name: MetricTypes.TWENTY_FOUR_MONTH_CAC,
    numerator: MetricTypes.TWENTY_FOUR_MONTH_CUSTOMER_CURRENCY_CPC_SPEND,
    denominator: MetricTypes.TWENTY_FOUR_MONTH_UNIQUE_CUSTOMER_COUNT,
  },
  [MetricTypes.META_AD_ACCOUNT_ID]: {
    type: MetricAggregationType.String,
    name: MetricTypes.META_AD_ACCOUNT_ID,
  },
  [MetricTypes.META_AD_ACCOUNT_NAME]: {
    type: MetricAggregationType.String,
    name: MetricTypes.META_AD_ACCOUNT_NAME,
  },
  [MetricTypes.ADSET_FIRST_USED]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_FIRST_USED,
  },
  [MetricTypes.ADSET_LAST_USED]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_LAST_USED,
  },
  [MetricTypes.ADSET_REGION]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_REGION,
  },
  [MetricTypes.ADSET_NAME]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_NAME,
  },
  [MetricTypes.ADSET_AUDIENCE]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_AUDIENCE,
  },
  [MetricTypes.ADSET_IS_CATALOG]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_IS_CATALOG,
  },
  [MetricTypes.CAMPAIGN_OBJECTIVE]: {
    type: MetricAggregationType.String,
    name: MetricTypes.CAMPAIGN_OBJECTIVE,
  },
  [MetricTypes.AUDIENCE_ENRICHMENT_ADSET_TARGETING]: {
    type: MetricAggregationType.String,
    name: MetricTypes.AUDIENCE_ENRICHMENT_ADSET_TARGETING,
  },
  [MetricTypes.ADSET_TARGETING]: {
    type: MetricAggregationType.String,
    name: MetricTypes.ADSET_TARGETING,
  },
  [MetricTypes.BENCHMARK_SAMPLE_SIZE]: {
    type: MetricAggregationType.Simple,
    name: MetricTypes.BENCHMARK_SAMPLE_SIZE,
  },
  [MetricTypes.BENCHMARKED_MER]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_MER,
  },
  [MetricTypes.BENCHMARKED_AMER]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_AMER,
  },
  [MetricTypes.BENCHMARKED_BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_BLENDED_AD_ATTRIBUTED_CONVERSION_ROAS,
  },
  [MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_IMPRESSION,
  },
  [MetricTypes.BENCHMARKED_BLENDED_AD_CLICK_THROUGH_RATE]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_BLENDED_AD_CLICK_THROUGH_RATE,
  },
  [MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_BLENDED_AD_COST_PER_CLICK,
  },
  [MetricTypes.BENCHMARKED_GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_GOOGLE_AD_ATTRIBUTED_CONVERSION_ROAS,
  },
  [MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_IMPRESSION,
  },
  [MetricTypes.BENCHMARKED_GOOGLE_AD_CLICK_THROUGH_RATE]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_GOOGLE_AD_CLICK_THROUGH_RATE,
  },
  [MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_GOOGLE_AD_COST_PER_CLICK,
  },
  [MetricTypes.BENCHMARKED_GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_GOOGLE_AD_RELATIVE_PERCENTAGE_SPEND,
  },
  [MetricTypes.BENCHMARKED_META_AD_ATTRIBUTED_CONVERSION_ROAS]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_META_AD_ATTRIBUTED_CONVERSION_ROAS,
  },
  [MetricTypes.BENCHMARKED_META_AD_COST_PER_IMPRESSION]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_META_AD_COST_PER_IMPRESSION,
  },
  [MetricTypes.BENCHMARKED_META_AD_CLICK_THROUGH_RATE]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_META_AD_CLICK_THROUGH_RATE,
  },
  [MetricTypes.BENCHMARKED_META_AD_COST_PER_CLICK]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_META_AD_COST_PER_CLICK,
  },
  [MetricTypes.BENCHMARKED_META_AD_RELATIVE_PERCENTAGE_SPEND]: {
    type: MetricAggregationType.Mean,
    name: MetricTypes.BENCHMARKED_META_AD_RELATIVE_PERCENTAGE_SPEND,
  },
};

export const getMetricData = (metric: MetricTypes): MetricAggregationData => {
  return MetricDataMap[metric];
};
